module.exports = __webpack_public_path__ + "img/kontak.33cce1df.svg";